import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getCounterpartiesListService } from '../services/counterparty.service';
import { TCounterpartiesListReqParams, TCounterpartiesListResData } from '../types/counterparty.types';

export const counterpartiesQueryKeys = createQueryKeys(EQueryKeys.CounterpartyQueryKeys, {
  getCounterpartiesList: (params: TCounterpartiesListReqParams = {}) => ({
    queryKey: ['counterparties-list-all', params],
    queryFn: (): Promise<TCounterpartiesListResData> => getCounterpartiesListService(params),
  }),
  getCounterparty: (params: TCounterpartiesListReqParams = {}) => ({
    queryKey: ['get-counterparty', params],
    queryFn: (): Promise<TCounterpartiesListResData> => getCounterpartiesListService(params),
  }),
  getMainCounterparty: (params: TCounterpartiesListReqParams = {}) => ({
    queryKey: ['get-main-counterparty', params],
    queryFn: (): Promise<TCounterpartiesListResData> => getCounterpartiesListService(params),
  }),
});
